"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.receiveStanzas = void 0;
var _types = require("./types");
// ====================================================================
// Typed actions
// ====================================================================

var receiveStanzas = exports.receiveStanzas = function receiveStanzas(stanzas) {
  return {
    type: _types.RECEIVE_STANZAS,
    value: {
      stanzas: stanzas
    }
  };
};